import React from "react";
import Select from "@components/select";
import { MARITAL_STATUS_OPTIONS } from "../../../../constants/options";
import { useFormikContext } from "formik";
import { useSetDefaultValue, usePendingPrefill } from "@hooks";

const name = "maritalStatus";

export default function MaritalStatus() {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <>
      <Select
        isPlaceHolder
        placeholder="Select..."
        title="Describe your marital status"
        options={MARITAL_STATUS_OPTIONS}

        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        errorMessage={touched[name] ? errors[name] : ""}
      />
    </>
  );
}
